export default {
    getChanges: state => {
        return state.divisionTimeChanges
    },
}
